import * as Lucide from "lucide-react";

export function Icon({ name, className, ...props }) {
  const Cmp = Lucide[name] || Lucide.Tag;
  return <Cmp className={className} {...props} />;
}

export const STATUS_META = {
  ACTIVE: { label: "Active", color: "#007AFF", bg: "#EAF3FF", icon: "ShieldCheck" },
  LOST: { label: "Lost", color: "#FF3B30", bg: "#FFECEA", icon: "TriangleAlert" },
  FOUND: { label: "Found", color: "#34C759", bg: "#EAF9EF", icon: "CircleCheck" },
  CLAIMED: { label: "Claimed", color: "#007AFF", bg: "#EAF3FF", icon: "ShieldCheck" },
  UNASSIGNED: { label: "Unassigned", color: "#8E8E93", bg: "#F2F2F4", icon: "CircleDashed" },
  GENERATED: { label: "Generated", color: "#8E8E93", bg: "#F2F2F4", icon: "CircleDashed" },
  PRINTED: { label: "Printed", color: "#8E8E93", bg: "#F2F2F4", icon: "Printer" },
  DISABLED: { label: "Disabled", color: "#A16207", bg: "#FEF3C7", icon: "PauseCircle" },
  REVOKED: { label: "Revoked", color: "#71717A", bg: "#F4F4F5", icon: "Ban" },
  INVALID: { label: "Invalid", color: "#71717A", bg: "#F4F4F5", icon: "CircleX" },
};

export function statusMeta(s) {
  return STATUS_META[s] || STATUS_META.UNASSIGNED;
}
